import React from 'react';

const FinishLine: React.FC = () => {
  return <div className="finish-line"></div>;
};

export default FinishLine;
